import button from './tokens/button.json';
import global from './tokens/global.json';
import input from './tokens/input.json';
import select from './tokens/select.json';
import switchToken from './tokens/switchToken.json';
import checkbox from './tokens/checkbox.json';
import card from './tokens/card.json';
import tag from './tokens/tag.json';
import table from './tokens/table.json';

const theme = {
  token: {
    ...global,
  },
  components: {
    Button: { ...button },
    // second type of Button
    Input: {
      ...input,
    },
    Select: {
      ...select,
    },
    Switch: {
      ...switchToken,
    },
    Checkbox: {
      ...checkbox,
    },
    Card: {
      ...card,
    },
    Tag: {
      ...tag,
    },
    Table: {
      ...table,
    },
  },
};

export default theme;
